import { Product } from '../../config/product';
import { IUpSellGenerateViewModel, IUpSellRenderModel } from '../../config/upsell-response';
import { View } from '../view';
export class UpSellSubscriptionView extends View {

    container = this.getDFContainer();

    render(model: IUpSellRenderModel) {
        const fields = document.createElement('div');
        fields.classList.add('single-sub-container');
        model.products.forEach(prod => {
            fields.appendChild(this.generateProductTemplate({
                product: prod,
                currency: model.currency,
                callback: model.callback,
                isOneProduct: model.isOneProduct
            }));
        });
        this.container.appendChild(fields);
    }

    generateProductTemplate(viewModel: IUpSellGenerateViewModel): HTMLElement {
        const elem = document.createElement('div');

        if (!viewModel.isOneProduct) {
            const selectInput = document.createElement('input') as HTMLInputElement;

            selectInput.type = 'checkbox';
            selectInput.classList.add('df-upsell-subscription-checkbox');
            selectInput.setAttribute('name', viewModel.product.name);
            selectInput.setAttribute('value', viewModel.product.amount.toString());
            selectInput.setAttribute('payment-type', viewModel.product.type);
            selectInput.setAttribute('id', viewModel.product.id || 'NoIdProvided');

            selectInput.onchange = (ev) => {
                viewModel.callback(viewModel.product, selectInput.checked);
            };

            elem.appendChild(selectInput);
        } else {
            viewModel.callback(viewModel.product, true);
        }

        const prodName = document.createElement('span');
        prodName.innerHTML = `${viewModel.product.name} - ${this.formatMoney(`${viewModel.product.amount}`, viewModel.currency)}
                                ${viewModel.product.maxCharges ? `/ ${viewModel.product.maxCharges} ${this.formatInterval(viewModel.product.interval)}` : ''}`;
        elem.append(prodName);

        if (viewModel.product.showQuantity) {
            const qContainer = document.createElement('span');
            qContainer.setAttribute('q-c-for', this.formProductName(viewModel.product.name));
            qContainer.innerHTML = ` x `;
            elem.append(qContainer);
        }

        return elem;
    }

    formatInterval(interval?: string) {
        return interval === 'monthly' ? 'months' : 'years';
    }

    formProductName(prodName: string) {
        return prodName.split(' ').join('');
    }

}
